import apiClient from '@/api/client';
import { API_GET_SAMPLE_SOURCES_ENDPOINT } from '@/api/config';
import type { SampleSource } from '@/models/models';
import { useEffect, useState } from 'react';

let catalogCache: SampleSource[] | null = null;
let catalogRequest: Promise<SampleSource[]> | null = null;

const loadCatalog = async (): Promise<SampleSource[]> => {
  if (catalogCache) return catalogCache;
  if (!catalogRequest) {
    catalogRequest = apiClient
      .get<SampleSource[]>(API_GET_SAMPLE_SOURCES_ENDPOINT)
      .then((response) => {
        catalogCache = response.data;
        return response.data;
      })
      .finally(() => {
        catalogRequest = null;
      });
  }
  return catalogRequest;
};

export const useSampleSourceCatalog = () => {
  const [sampleSources, setSampleSources] = useState<SampleSource[]>(
    catalogCache ?? []
  );
  const [loading, setLoading] = useState(catalogCache === null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    if (catalogCache) {
      setSampleSources(catalogCache);
      setLoading(false);
      return () => {
        active = false;
      };
    }

    void loadCatalog()
      .then((catalog) => {
        if (active) {
          setSampleSources(catalog);
          setError(null);
        }
      })
      .catch((requestError) => {
        console.error('Error fetching sample-source catalog:', requestError);
        if (active) setError('Failed to load sample sources');
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { sampleSources, loading, error };
};
